
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import DepartmentsContent from "./components/DepartmentsContent.vue";

export default defineComponent({
  name: "JourneysPage",
  components: {
    BreadCrumb,
    DepartmentsContent,
  },
});
